<template>
    <ReaderModal :aria-label="localizations[lang].print.title" :fixed-height="false" @close-modal="closePrintControl">
        <template #header>
            <div class="flex items-center px-4 pb-1 pt-3">
                <svg-icon icon="baseline-print-24px" class="mr-2 text-theme-icon" width="20px" height="20px" />
                <h2 class="font-noto-sans my-auto text-left font-medium leading-6 text-theme-text">
                    {{ localizations[lang].print.title }}
                </h2>
            </div>
        </template>

        <div class="flex w-full flex-col gap-6 p-4 pt-2">
            <p class="text-sm text-theme-text">{{ allowanceLeadText }}</p>

            <div class="flex flex-col items-center gap-0.5">
                <span class="sr-only">{{ gaugeText }} {{ localizations[lang].print.gaugeLabel }}</span>
                <span class="text-xl font-bold text-theme-icon" aria-hidden="true">{{ gaugeText }}</span>
                <span class="text-xs uppercase tracking-wide text-theme-toolbar-icon" aria-hidden="true">
                    {{ localizations[lang].print.gaugeLabel }}
                </span>
            </div>

            <p class="mt-0.5 text-xs text-theme-toolbar-icon">{{ jobLimitText }}</p>

            <PrintRangeForm
                v-if="!isLifetimeQuotaExhausted"
                :total-book-pages="publicationNumberOfPages"
                :print-limit-per-job="printControl.printLimitPerJob"
                :remaining-pages="printRemainingPages"
                :printed-pages="printControl.printedPages"
                @submit="onSubmitRange"
            />
            <p v-else role="status" class="text-sm text-theme-text">{{ localizations[lang].print.quotaExhausted }}</p>

            <PrintHistoryList :items="printControl.history" @reprint="onReprint" />
        </div>
    </ReaderModal>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import ReaderModal from '../ReaderModal/ReaderModal.vue';
import PrintRangeForm from './PrintRangeForm.vue';
import PrintHistoryList from './PrintHistoryList.vue';

export default {
    name: 'PrintControlModal',

    components: {
        ReaderModal,
        PrintRangeForm,
        PrintHistoryList,
    },

    computed: {
        ...mapState(['printControl', 'fileType', 'localizations', 'lang']),
        ...mapGetters([
            'printUsedPages',
            'printRemainingPages',
            'isLifetimeQuotaExhausted',
            'publicationNumberOfPages',
        ]),
        allowanceLeadText() {
            return this.localizations[this.lang].print.allowanceLead.replace(
                '{total}',
                this.printControl.lifetimeTotalPages
            );
        },
        gaugeText() {
            return this.localizations[this.lang].print.gauge
                .replace('{used}', this.printUsedPages)
                .replace('{total}', this.printControl.lifetimeTotalPages);
        },
        jobLimitText() {
            return this.localizations[this.lang].print.jobLimit.replace('{limit}', this.printControl.printLimitPerJob);
        },
    },

    methods: {
        ...mapMutations(['closeFeature']),
        ...mapActions(['requestPrintPages']),
        closePrintControl() {
            this.closeFeature({ featureKey: 'printModal' });
        },
        /**
         * Handles a new print request from the range form.
         * @param {{ pageFrom: number, pageTo: number }} range
         */
        onSubmitRange({ pageFrom, pageTo }) {
            this.requestPrintPages({ fileType: this.fileType, pageFrom, pageTo, source: 'new' });
            this.closePrintControl();
        },
        /**
         * Handles a reprint request from the history (does not consume quota).
         * @param {{ pageFrom: number, pageTo: number }} entry
         */
        onReprint(entry) {
            this.requestPrintPages({
                fileType: this.fileType,
                pageFrom: entry.pageFrom,
                pageTo: entry.pageTo,
                source: 'history',
            });
            this.closePrintControl();
        },
    },
};
</script>
